export default __webpack_public_path__ + "static/media/galery_photo4@2x.9cd9c80a.png";